import Switch from './components/Switch';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'switch',
  pluginComponent: Switch,
});
